import { render, staticRenderFns } from "./studentAchievement.vue?vue&type=template&id=ac0528ec&scoped=true"
import script from "./studentAchievement.vue?vue&type=script&lang=js"
export * from "./studentAchievement.vue?vue&type=script&lang=js"
import style0 from "./studentAchievement.vue?vue&type=style&index=0&id=ac0528ec&prod&lang=less"
import style1 from "./studentAchievement.vue?vue&type=style&index=1&id=ac0528ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0528ec",
  null
  
)

export default component.exports